import "./build-operate-transfer.css";
import { useNavigate } from "react-router-dom";
import useLocalizedPath from "../../../components/use-localized-path";
import { useTranslation } from "react-i18next";
import Timeline from "../../../components/timeline/timeline-comp";

export default function BuildOperateTransfer() {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const localize = useLocalizedPath();
  const goToContact = () => {
    navigate(localize("/contact-us"));
  };

  const goToAbout = () => {
    navigate(localize("/about-us"));
  };

const timelineData = [
  {
    date: "01",
    title: "Expert Project Delivery",
    content: "Expert project execution with industry best practices.",
  },
  {
    date: "02",
    title: "Risk Reduction & Efficiency",
    content: "Reduced project risks and improved outcomes.",
  },
  {
    date: "03",
    title: "Seamless Knowledge Transfer",
    content: "Seamless knowledge transfer and handover.",
  },
  {
    date: "04",
    title: "Resource Optimization & Security",
    content: "Mitigation of resource constraints and skill gaps.",
  },
  {
    date: "05",
    title: "Business-Aligned Scalability",
    content: "Alignment of project deliverables with your business objectives.",
  },
];


const challenges = [
  {
    number: "01",
    text: "Challenges in executing complex projects due to resource constraints and limited expertise.",
  },
  {
    number: "02",
    text: "Risks associated with knowledge transfer and handover leading to delays and budget overruns.",
  },
  {
    number: "03",
    text: "Difficulty in maintaining operational efficiency and alignment with business objectives during the transition phase.",
  },
];


  const cards = [
    {
      icon: "fa-solid fa-industry",
      title: "Specialized BOT Execution",
      text: "Specialized in BOT model project execution.",
    },
    {
      icon: "fa-solid fa-people-carry-box",
      title: "Resources & Methodologies",
      text: "Resources, best practices, and project management methodologies.",
    },
    {
      icon: "fa-solid fa-handshake",
      title: "Ownership & Seamless Transition",
      text: "Complete ownership, seamless transition to your organization upon completion.",
    },
  ];

  return (
    <div className="main-container">
      {/* main image section */}
      <section className="main-image-section build-main-section">
        <div className="main-image-dark-effect">
          <p className="sub-container-sub-heading">{t("Services")}</p>
          <h1 className="sub-container-heading">{t("Build, Operate & Transfer")}</h1>
          <p className="sub-container-desc">
            {t("The Build, Operate, and Transfer (BOT) model enables efficient project execution we build and manage the solution, ensure performance and scalability, and seamlessly transfer ownership for long-term success.")}
          </p>
          <div className="main-img-container-buttons">
            <button
              type="button"
              className="img-contact-btn common-btn-styles"
              onClick={goToContact}
            >
              {t("Contact Us")}
            </button>
            <button
              type="button"
              className="img-about-btn common-btn-styles"
              onClick={goToAbout}
            >
              {t("About Us")}
            </button>
          </div>
        </div>
      </section>

      {/* service overview section */}
      <section className="service-overview">
        <div className="service-overview-width sub-container">
          <div>
            <h2 className="sub-container-heading">{t("Service Overview")}</h2>
          </div>

          <div className="service-img-container">
            <div className="service-image">
              <img
                src="/assets/images/build-service-overview.webp"
                alt={t("Build Services Overview")}
              />
            </div>

            {/* Right Content */}
            <div className="service-content">
              <p>
                {t("Our Build, Operate & Transfer (BOT) model delivers complete project execution from setup to operation ensuring efficiency, scalability, and a smooth transition of ownership for long-term success.")}
              </p>
                <ul>
                <li>
                    <i className="fa-solid fa-angles-right"></i>
                    {t("Build, Operate, and Transfer (BOT) model for seamless project execution.")}
                </li>
                <li>
                    <i className="fa-solid fa-angles-right"></i>
                    {t("Domain knowledge and project management expertise aligned with your objectives.")}
                </li>
                <li>
                    <i className="fa-solid fa-angles-right"></i>
                    {t("End-to-end operational support ensuring efficiency, scalability, and smooth ownership transition.")}
                </li>
                </ul>

            </div>
          </div>
        </div>
      </section>

      {/*challenges secton*/}
      <section className="challenges-section sub-container">
        <h2 className="sub-container-heading">{t("Challenges")}</h2>
        <p className="sub-container-desc">
            {t("Common Build, Operate & Transfer (BOT) challenges organizations face in today’s evolving digital landscape.")}
        </p>

        <div className="challenges-container">
          {challenges.map((item, index) => (
            <div
              className="challenge-box"
              key={index}
              data-number={item.number}
            >
              <p className="challenge-text">{t(item.text)}</p>
            </div>
          ))}
        </div>
      </section>

      {/* how are we solving section */}
      <section className="solving-section">
        <div className="solving-section-container sub-container">
          <h2 className="sub-container-heading">{t("How Are We Solving")}</h2>
          <p className="sub-container-desc">
            {t("We combine strategic insight, technical expertise, and collaboration to deliver Build, Operate & Transfer solutions that streamline execution, minimize risks, and ensure smooth transitions for lasting success.")}
          </p>

          <div className="solving-cards">
            {cards.map((card, index) => (
              <div className="solving-card" key={index}>
                <div className="icon-wrapper">
                  <i className={card.icon}></i>
                </div>
                <h3>{t(card.title)}</h3>
                <p>{t(card.text)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* benefits section */}
      <section className="benefits-section sub-container">
        <h2 className="sub-container-heading">{t("Benefits")}</h2>
        <p className="sub-container-desc">
          {t("With the quality and approach, we would be delivering the best of what you’d need in consulting, suggesting, providing right solutions thus yielding best benefits for your organizations productivity.")}
        </p>
        <div>
          <Timeline timelineData={timelineData} />
        </div>
      </section>
    </div>
  );
}
